import {css} from '@emotion/react';
import styled from '@emotion/styled';
import {rgba} from 'polished';

export const toolbarDropdownStyle = css`
  display: flex;
  flex-direction: column;
  pointer-events: none;
`;

export const Toolbar = styled.div`
  width: auto;
  border-radius: 40px;
  overflow: visible;
  display: flex;
  flex-direction: row;
  background: #1D1D1D;
  color: #fff;
  pointer-events: all;
  padding: 5px;
`;

export const DropdownContainer = styled.div`
  min-width: 300px;
  background: ${({theme: {dropdownBackground}}) => dropdownBackground};
  color: #fff;
  pointer-events: all;
`;

export const DropdownFields = styled.div`
  display: flex;
  flex-direction: column;
  padding-bottom: 1px;

  ${DropdownContainer} > & {
    padding-bottom: 0.5em;
  }
`;

export const toolbarFieldStyle = ({textColor, borderColor}) => css`
  flex: 1 1 auto;
  padding: 0.5em 1em;
  margin: 0;
  white-space: nowrap;
  display: flex;
  align-items: center;
  font-size: 1em;
  user-select: none;
  color: ${textColor};

  ${DropdownFields} > &,
  ${DropdownFields} > .item & {
    border-top: 1px solid ${borderColor};
  }

  ${Toolbar} & {
    border-top: 0;
    margin: 0;
    padding: 8px;
    margin-right: 5px;
    background-color: #2A2A2A;
    min-width: 40px;
    height: 40px;
    text-align: center;
    align-items: center;
    justify-content: center;
    transition: background 0.1s ease-out;
    border-radius: 999px;

    &:hover{
      background-color: #484848;
    }

    :last-of-type {
      margin-right: 0;
    }
  }
`;

export const toolbarFieldActiveStyle = css`
  ${Toolbar} & {
    background-color: #D1D7FA !important;
    color: #2B4BFF;

    img {
      filter: brightness(0.5) sepia(1) saturate(73) hue-rotate(231deg);
    }
  }
`;

export const toolbarButtonStyle = [
  toolbarFieldStyle,
  css`
    flex: 0 0 auto;
    transition: background 0.1s ease-out;
    cursor: pointer;
  `,
];

export const ToolbarLabelWrapper = styled.div`
  flex: 1 1 0;
  display: flex;
  flex-direction: row;
  align-items: center;
  font-size: 1em;

  ${Toolbar} & {
    justify-content: center;
  }
  ${({labelLast}) => labelLast
  ? css`
  
    order: 999;
    margin-left: 0.75rem;
    `
  : ''};
 
`;

export const toolbarButtonActionStyle = [
  toolbarButtonStyle,
  css`
    :hover {
      background: #0070b4;
    }
  `,
];

export const toolbarButtonWarnStyle = [
  toolbarButtonStyle,
  css`
    :hover {
      background: #ff3b30;
    }
  `,
];

export const toolbarInputStyle = ({inputBackground, inputBackgroundActive, inputBorderColor, inputBorderColorActive, inputBorderColorHover, textColor}) => css`
  outline: 0;
  appearance: none;
  color: inherit;
  resize: vertical;
  font-size: inherit;
  color: ${textColor};
  flex: 1 1 auto;
  padding: 0 1ch;
  font-weight: normal;
  line-height: 2.2;
  user-select: auto;
  border-radius: 5px;
  background: ${inputBackground};
  border: 1px solid ${inputBorderColor};
  transition: background 0.1s ease-out, border 0.1s ease-out;

  :hover {
    background: ${inputBackgroundActive};
    border: 1px solid ${inputBorderColorHover};
  }

  :focus,
  :active {
    background: ${inputBackgroundActive};
    border: 1px solid ${inputBorderColorActive};
  }
`;

export const toolbarInputStyleStealth = ({inputBorderColor}) => css`
  line-height: 1.5;
  background: inherit;
  border: 1px solid ${rgba(inputBorderColor, 0)}
`;

export const toolbarDropdownDistance = 10;

export const resizeHandleStyle = css`
  position: absolute;
  width: 8px;
  height: 8px;
  pointer-events: all;
  border-radius: 50%;
`;
export const anchorHandleStyle = css`
  position: absolute;
  width: 0;
  height: 0;
  pointer-events: all;
  border-radius: 0;
`;

export const dropdownBgStyle = css`
  border-radius: 13px;
  box-shadow: 0 2px 6px 0 rgba(0, 0, 0, 0.4);
  overflow: hidden;
`;

export const toolbarCircleButton = css`
  margin-right: 0.5em;
  width: 24px;
  height: 24px;
  border-radius: 24px;
  display: flex;
  justify-items: center;
  align-items: center;
  justify-content: center;

  text-align: center;
  cursor: pointer;
  background: #575757;
  :hover {
    background: #5792e5;
  }
`;

export const MenuIconCircle = styled.div`
  width: 40px;
  height: 40px;
  line-height: 40px;
  text-align: center;
  margin-right: 20px;
  border-radius: 50%;
  background-color: #2A2A2A;
`;

export const MenuHeaderRow = styled.div`
  display: flex;
  background-color: #2F2E31;
  padding: 0.5em 1em;
  padding-bottom: 0.35em;
  flex-direction: row;
`;

export const MenuFooterRow = styled.div`
  border-top: 1px solid #232325;
  display: flex;
  background-color: #2F2E31;
  flex-direction: row;
  padding-bottom: 0.15em;

  ${DropdownFields} > & {
    margin-bottom: -0.5em;
  }
`;

export const MenuFooterPlaceholder = styled.div`
  flex: 1 1 100%;
`;

export const MenuFooterButton = styled.div(
  css`
    flex: 1 1 100%;
    display: block;
    padding: 0.6em 1em;
    color: #ACACAC;
    text-align: center;
    transition: color 0.1s ease-out;
    opacity: 0.4;
    cursor: default;
  `,
  ({disabled}) => !disabled && css`
    opacity: 1;
    cursor: pointer;

    :hover {
      color: #fff;
    }
  `,
);

export const MenuHeaderButton = styled.div(
  css`
    margin-left: 1em;
    flex: 0 0 0;
    display: block;
    padding: 0;
    color: #ACACAC;
    text-align: center;
    text-transform: uppercase;
    font-size: 0.9em;
    transition: color 0.1s ease-out;
    opacity: 0.4;
    cursor: default;
  `,
  ({disabled}) => !disabled && css`
    opacity: 1;
    cursor: pointer;

    :hover {
      color: #fff;
    }
  `,
);

export const MenuHeaderColumn = styled.div`
  flex: 1 1 auto;
  display: flex;
  flex-direction: column;
  justify-content: center;
`;

export const MenuHeaderTitle = styled.div`
  font-weight: 600;
  line-height: 1.4;
  text-transform: uppercase;
  font-size: 0.9em;
`;

export const MenuHeaderSubtitle = styled.div`
  font-size: 0.8em;
`;

export const TabRow = styled.div`
  display: flex;
  flex: 0 1 auto;
  flex-direction: row;
  border-radius: 5px;
  background-color: #101012;
  padding: 2px;
  overflow: hidden;
`;

const tabStyle = css`
  flex: 1 1 auto;
  color: #fff;
  cursor: pointer;
  padding: 2px 12px;
  border-radius: 5px;
  text-align: center;
  transition: background 0.1s ease-out;

  :hover {
    background-color: #201F22;
  }
`;

export const StyledTab = styled.div(
  tabStyle,
  ({selected}) => selected && css`
    background-color: #2F2E31;
  `,
);

export const StyledTabButton = styled.div(
  tabStyle,
  css`
    flex: 0 0 auto;
    padding: 2px 6px;
  `,
  ({disabled}) => disabled && css`
    &, &:hover {
      background-color: #101012;
      color: #A5A5A5;
      cursor: default;
    }
  `,
);

export const VideoToolbar = styled.div`
  position: absolute;
  top: 1em;
  right: 1em;

  &.qbrick {
    z-index: 999999;
  }
`;

export const FieldButtonsRow = styled.div`
  display: flex;
  flex-direction: row;
  border-radius: 5px;
  overflow: hidden;
  margin-left: 0.5em;
`;
export const FieldButton = styled.div`
  position: relative;
  padding: 0 0.75em;
  color: ${({disabled}) => disabled ? '#A5A5A5' : '#fff'};
  cursor: ${({disabled}) => disabled ? 'default' : 'pointer'};
  background-color: #2F2E31;
  text-align: center;
  line-height: 1.5em;
  transition: background 0.1s ease-out;
  :hover {
    background-color: #484848;
  }
  ::after {
    content: '';
    display: block;
    position: absolute;
    right: -1px;
    top: 50%;
    height: 1em;
    transform: translateY(-50%);
    background: #3D3D3F;
    width: 2px;
    border-radius: 1px;
    z-index: 1;
  }
  :last-of-type::after {
    display: none;
  }
`;